var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import WaiverZeroApp from "~/components/collection-manage/collection-application/waiver-zero-app.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseApplyOperateService } from "~/services/domain-service/case-apply-operate.service";
var collectionManageModule = namespace("collection-manage");
var ReductionZeroApplication = /** @class */ (function (_super) {
    __extends(ReductionZeroApplication, _super);
    function ReductionZeroApplication() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = { state: false };
        _this.dataSet = [];
        _this.dialog = { waiverApp: false };
        _this.queryParamsModel = {
            caseId: "",
            applyType: "DERATE_CLEAR_APPLY"
        };
        return _this;
    }
    ReductionZeroApplication.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.queryParamsModel.caseId = this.caseId;
        this.caseApplyOperateService.caseApplySearch(this.queryParamsModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], ReductionZeroApplication.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], ReductionZeroApplication.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseApplyOperateService)
    ], ReductionZeroApplication.prototype, "caseApplyOperateService", void 0);
    __decorate([
        collectionManageModule.State
    ], ReductionZeroApplication.prototype, "caseId", void 0);
    ReductionZeroApplication = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                WaiverZeroApp: WaiverZeroApp
            }
        })
    ], ReductionZeroApplication);
    return ReductionZeroApplication;
}(Vue));
export default ReductionZeroApplication;
